import { inject, observer } from "mobx-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { pdfjs } from "react-pdf";
import { Text } from "../UI";
import InlineSignPdf from "./InlineSignPdf";

// signature placeholder token in the PDF
const SIG_PATTERN = /sig\d+/i;

const TenantChangeSignModal = ({ tenantsStore, tenantsChooseStore }) => {
  const theme = useTheme();
  const { t } = useTranslation("lobby");

  useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  }, []);

  const space = tenantsStore?.selectedSiteSpace;
  const base = space?.SPACENAME
    ? { CUST: space.CUST, MAINENV: space.DNAME, SPACENAME: space.SPACENAME }
    : null;

  const pdf = tenantsChooseStore?.changeSignDocPdf;

  const saveSigned = async (signedBase64) => {
    if (!base) return;
    const saved = await tenantsChooseStore.addTenantChangeSignDoc({
      ...base,
      EXTFILENAME: signedBase64,
    });
    if (!saved || tenantsChooseStore.error) throw new Error("save-failed");
    await tenantsChooseStore.getTenantChangeSignDoc(base);
    tenantsChooseStore.closeSignModal();
  };

  if (!tenantsChooseStore?.signModalOpen || !pdf) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(33,42,49,0.45)",
        zIndex: 1100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div
        style={{
          backgroundColor: theme.color.white,
          borderRadius: 16,
          padding: 20,
          width: "min(780px, 96vw)",
          maxHeight: "92vh",
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
          gap: 12,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Text.SB color={theme.color.navy}>{t("changes_sign_title")}</Text.SB>
          <button
            type="button"
            onClick={() => tenantsChooseStore.closeSignModal()}
            aria-label="close"
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              fontSize: 20,
              color: theme.color.gray90,
              lineHeight: 1,
            }}
          >
            ✕
          </button>
        </div>
        <InlineSignPdf
          pdfBase64={pdf}
          placeholder={SIG_PATTERN}
          onCancel={() => tenantsChooseStore.closeSignModal()}
          onSaved={saveSigned}
        />
      </div>
    </div>
  );
};

export default inject(
  "tenantsStore",
  "tenantsChooseStore"
)(observer(TenantChangeSignModal));
